/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'

export default {
  CREATE_ONLINETEST(state, payload) {
    state.onlineTests.unshift(payload)
  },
  UPDATE_ONLINETEST(state, payload) {
    var index = state.onlineTests.findIndex(function(item){return item.id == payload.id})
    if (index != -1) {
      state.onlineTests[index].update_time = payload.update_time
      state.onlineTests[index].file_names = payload.file_names
      state.onlineTests[index].title = payload.title
      state.onlineTests[index].timeout = payload.timeout
      state.onlineTests[index].detail = payload.detail
      state.onlineTests[index].start_time = payload.start_time
      state.onlineTests[index].end_time = payload.end_time
    }
  },
  UPDATE_ONLINETEST_TITLE(state, payload) {
    var index = state.onlineTests.findIndex(function(item){return item.id == payload.id})
    state.onlineTests[index].title = payload.title
    state.onlineTests[index].detail = payload.detail
  },
  DELETE_ONLINETEST(state, payload) {
    var index = state.onlineTests.findIndex(function(item){return item.id == payload})
    if(index != -1){
      state.onlineTests.splice(index,1)
    }
  },
  SET_ONLINETEST_SEARCH_QUERY(state, payload){
    state.onlineTestSearchQuery = payload
  },
  SET_ACTIVE_ONLINETEST(state, payload) {
    state.ActiveOnlineTest = payload
  },
  SET_ONLINETEST_LIST(state, payload){
    if (payload){
      state.onlineTests = payload.sort(function(a,b) {return a.update_time > b.update_time ? -1 : a.update_time > b.update_time ? 1 : 0 })
    } else {
      state.onlineTests = []
    }
  },
  SET_ONLINETEST_DATE_UPDATE(state, payload){
    Vue.set(state.onlineTests[payload.index], 'state_val', payload.val)
  },
  SET_ONLINETEST_MEMBER_LIST(state, payload) {
    state.onlineTestMembers = payload
  },
  CREATE_ONLINETEST_MEMBER(state, payload) {
    state.onlineTestMembers.unshift(payload)
  },
  UPDATE_ONLINETEST_MEMBER_SCORE(state, payload){
    var index = state.onlineTestMembers.findIndex(function(item){return item.id == payload.id})
    state.onlineTestMembers[index].score = payload.score
    state.onlineTestMembers[index].comment = payload.comment
  },
  UPDATE_ONLINETEST_MEMBER(state, payload) {
    var index = state.onlineTestMembers.findIndex(function(item){return item.id == payload.id})
    state.onlineTestMembers[index].title = payload.title
    state.onlineTestMembers[index].detail = payload.detail
    state.onlineTestMembers[index].update_time = payload.update_time
    state.onlineTestMembers[index].file_name = payload.file_name
  },
  DELETE_ONLINETEST_MEMBER(state, payload) {
    var index = state.onlineTestMembers.findIndex(function(item){return item.id == payload})
    if(index != -1){
      state.onlineTestMembers.splice(index,1)
    }
  },
}
